import React, { Component } from 'react';
import Snap from 'snapsvg-cjs';
import {glyphs} from '../../settings';
import {
  calculateF,
  calculateR,
  calculateA,
  calculateM,
  calculateO
} from '../../utils/glyphs_1';
import './Glyph.css';


const path = {
  F: calculateF,
  R: calculateR,
  A: calculateA,
  M: calculateM,
  O: calculateO
}

class Glyph extends Component{

  constructor(props) {
    super(props);
    this.svg = React.createRef();
  }

  shouldComponentUpdate(){
    return false;
  }

  componentDidMount(){
    let {width, height} = this.props.size;
    let {glyph} = this.props;

    let paths = path[glyph](width, height);
    this.snap = Snap(this.svg.current);
    this.snap.attr(glyphs.snapAttr)

    this.glyphPaths = [];
    paths.forEach((path,i) => {
      this.glyphPaths[i] = this.snap.path(path.d).attr({ strokeWidth: path.strokeWidth});
    })

  }

  componentWillReceiveProps(newProps){
    let {width, height} = newProps.size;
    if(width !== this.props.size.width || height !== this.props.size.height){
      this.onResize(width, height);
    }
  }

  onResize(width,height){
    let {glyph} = this.props;
    let paths = path[glyph](width, height);

    setTimeout(()=>{
      paths.forEach((path, i) => {
        this.glyphPaths[i].animate(path,200);
      });
    }, 100);

  }

  render(){
    return (
      <div ref={this.container} className="Letter-container">
        <svg ref={this.svg} className="Letter-svg"  />
      </div>
    )
  }
}

export default Glyph;



// WEBPACK FOOTER //
// ./src/components/galleryItems/Glyph.js